/**
 * Rounds a number with progressive resolution based on size
 */
const round = (n: number) => {
  let resolution = 1;

  if (n < 1000) {
    return Math.round(n);
  } else if (n < 10_000) {
    resolution = 10;
  } else if (n <= 100_000) {
    resolution = 100;
  } else if (n <= 1_000_000) {
    resolution = 1000;
  } else {
    resolution = 10_000;
  }

  return Math.round(n / resolution) * resolution;
};

export default round;
